"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";

const GTAG_ID = "G-LG5Y5D8YK6";

export function GoogleAnalytics() {
  const pathname = usePathname();
  if (pathname === "/security/challenge") return null;

  return (
    <>
      <Script src={`/metrics/?id=${GTAG_ID}`} strategy="afterInteractive" />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GTAG_ID}');
        `}
      </Script>
    </>
  );
}
